import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRouteSnapshot} from '@angular/router';

import {SfAnalyticsService} from '../../sf-analytics/services/sf-analytics.service';

@Injectable()
export class SfAnalyticsResolve {
  constructor(
    private sfAnalyticsService: SfAnalyticsService,
    private titleService: Title
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const refModelId = route.params['refModelId'];
    const chartsQueryParams = route.queryParams['filters']
      ? JSON.parse(route.queryParams['filters'])
      : {};
    if (chartsQueryParams) {
      this.sfAnalyticsService.updateQueryParamsForCharts(null, null, true, chartsQueryParams);
    }
    this.titleService.setTitle('Salesforce Org Analytics');
    return this.sfAnalyticsService.fetchSfAnalytics(refModelId);
  }
}
